import { Fade, Slide, Zoom } from 'react-reveal';
import styled from 'styled-components';
import Workshop2 from './Workshop2';
import './Workshop.css'
import workshop_img from '../../assets/img/Workshop-img.png'
import { Link } from 'react-router-dom';
function Workshop() {

    return (

        <Container>
            <div >
                <div>
                    <Slide down>
                        {/* <Slide right> */}
                        <div className='container text-center py-5 name'>

                            <h1 className='text-black'>Encouraging a culture where <span>IDEAS</span> are welcomed rather than <span>FEARED</span></h1>
                            <p className='text-black font-weight-bold'>"For Startup Founders"</p>
                            <Link to="/membership"><button>March Forward</button></Link>
                        </div>
                        <hr />


                        {/* </Slide> */}

                    </Slide>

                </div>
                {/* <Fade left>
                <div className="banner-img">
                    <img src={workshop_img} alt="" />
                </div>

            </Fade> */}

                <DirectPhone>
                    <Zoom>

                        <a href="tel:01-5245116">
                            <i class="fa-solid fa-phone"></i>
                        </a>
                    </Zoom>

                </DirectPhone>

                <LeftContainer className='container'>

                </LeftContainer>


            </div>

            <Workshop2 />

        </Container>
    )
}

export default Workshop
const Container = styled.div`
                  .banner-img img{
                        width:100%;
                        height:600px ;
                        object-fit:cover ;
                    }
                   
                    @media (max-width:700px){
                       .banner-img img{
                            height:400px ;
                        }
                    }
                    position:relative ;
                    font-family:Arial, Helvetica, sans-serif ;
                    button{
                        background-color:#FA7525 ;
                        color:white ;
                        font-size:20px ;
                        border:none ;
                        padding:10px 20px 10px 20px ;       
                        border-radius:5px ;
                        /* margin-left:25px ; */
                        &:hover{
                            background-color:black;
                            color:white;
                        }

                    }
                    margin-top:80px ;

`
const LeftContainer = styled.div` 
position:absolute ;
line-height:2em ;
width:45rem;
top:150px;
left:50px;
color:white ;
                        span{
                            color:#FA7525 ;
                        }




                    h1{
                        line-height:1.2em ;
                        margin-top:-10px ;
                        /* font-size:3vw ; */
                        text-transform:uppercase ;
                        font-weight:bold ;
                    }
                    p{
                        color:#FA7525;
                        color:white ;
                        margin-left:25px ;
                        /* font-size:1.5em ; */
                    }

/* 
                    span{
                        font-weight:bold ;
                        color:#FA7525 ;
                        font-family:sans-serif ;
                    } */

                    @media (max-width: 700px){
                    width:100% ;
                    left:0 ;
                    top:100px ;

                    h1{
                        font-size:24px ;
                    }
}
`

const DirectPhone = styled.div` 
position:fixed ;
top: 300px ;
right:0;
font-size:22px ;
background-color:#FA7525 ;
padding:10px;
color:white ;
border-radius:5px 0 0 5px ;
z-index:1 ;
text-align:center ;

                    a{
                        color: white ;
                        text-decoration:none ;
                    }
                    &:hover a{
                        color:black ;

                    }
`
